import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Heading, Image, Text } from "grommet";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Home } from "grommet-icons";
import { floor } from "lodash";

interface FloorPlan {
    id: string;
    name: string;
    image: string;
    isActive: boolean;
}

const FloorPlan = () => {
    const navigate = useNavigate();
    const [floorPlans, setFloorPlans] = useState<FloorPlan[]>([]);
    const [activeFloorPlan, setActiveFloorPlan] = useState<FloorPlan | null>(null);

    useEffect(() => {
        axios
            .get(`${Server}/api/floorPlans`)
            .then((res) => {
                if (res.status === 200) {
                    const fps = res.data.filter((f: { isActive: any }) => f.isActive);
                    setFloorPlans(fps);
                    setActiveFloorPlan(fps[0]);
                } else {
                    alert("Error getting FloorPlans");
                }
            })
            .catch(() => {
                alert("Error getting FloorPlans");
            });
    }, []);

    return (
        <Box pad="medium" align="center" fill gap={"small"}>
            <Grid columns={["1fr", "auto", "1fr"]} width="100%" align="center">
                <Home color="brand" onClick={() => navigate("/home")} />
                <Heading level="2" color="brand">
                    Event Map
                </Heading>
                <Box direction="row" gap="small" align="center" justify="end"></Box>
            </Grid>

            {floorPlans.length != 1 && (
                <Box direction="row" gap="small" margin={{ bottom: "medium" }} wrap>
                    {floorPlans.map((fp) => (
                        <Button key={fp.id} label={fp.name} onClick={() => setActiveFloorPlan(fp)} primary={fp.id === activeFloorPlan?.id} />
                    ))}
                </Box>
            )}

            {activeFloorPlan && (
                <Box align="center" justify="center" pad="none" overflow="auto" round="medium" fill style={{ borderRadius: "10px" }}>
                    <TransformWrapper minScale={0.2} maxScale={5} wheel={{ step: 0.1 }} doubleClick={{ disabled: false, step: 1 }} pinch={{ step: 5 }}>
                        <TransformComponent>
                            <Image src={activeFloorPlan.image} alt="FloorPlan" fit="contain" style={{ maxWidth: "100%", maxHeight: "90vh", borderRadius: "10px" }} />
                        </TransformComponent>
                    </TransformWrapper>

                    {/* <Box margin={{ top: "medium" }}>
                        <Button label="Download High Resolution" color="white" onClick={() => window.open(activeFloorPlan.image, "")} />
                    </Box> */}
                </Box>
            )}
        </Box>
    );
};

export default FloorPlan;
